import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

import "components/utils/StepperEditor/stepper-editor.scss";

function StepperEditor(props) {
  const [activeStep, setActiveStep] = useState(props.activeStep);
  const [nonLinear, setNonLinear] = useState(props.nonLinear);

  useEffect(() => {
    if (activeStep !== props.activeStep) {
      setActiveStep(props.activeStep);
    }
    if (nonLinear !== props.nonLinear) {
      setNonLinear(props.nonLinear);
    }
  }, [props]);

  return (
    <div className="stepper-editor-container">
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        nonLinear={props.nonLinear}
      >
        {props.steps.map((step, index) => (
          <Step key={`step_${index}`}>
            <StepLabel
              className={`${props.goToStep && activeStep > index ? "hoverable" : ""} ${step.icon ? "has-icon" : ""}`}
              icon={step.icon ? step.icon : index + 1}
              onClick={() =>
                props.goToStep && activeStep > index
                  ? props.goToStep(index)
                  : ""
              }
            >
              {step.label}
              {step.label_node}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

StepperEditor.propTypes = {
  goToStep: PropTypes.func,
  nonLinear: PropTypes.bool,
  activeStep: PropTypes.number,
  steps: PropTypes.array.isRequired,
};

export default StepperEditor;
